import { render, staticRenderFns } from "./ServiceSetup.vue?vue&type=template&id=170733b3&scoped=true&"
import script from "./ServiceSetup.vue?vue&type=script&lang=js&"
export * from "./ServiceSetup.vue?vue&type=script&lang=js&"
import style1 from "./ServiceSetup.vue?vue&type=style&index=1&id=170733b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170733b3",
  null
  
)

export default component.exports